const required = (value) => {
  if (value === undefined)
    throw new Error('This field is required')
}
const addressText = (value) => {
  if (value.trim().length <= 0)
    throw new Error('This field is required')
}

const text = (value) => {
  if (value.trim().length === 0)
    throw new Error("Please enter contact name")
  else if (value.trim().length > 36)
    throw new Error("This field accepts 36 characters")
  else if (!/^[a-zA-Z\s]*$/.test(value.match(/[^A-Za-z\s]/gi, "")))
    throw new Error("This field accepts alphabets")
}

const address = (value) => {
  text(value)
}

const phoneNumber = (value) => {
  if (value === '') return
  if (!/^[1-9]\d{9}$/g.test(value.replace(/\s+/g, '')))
    throw new Error('Invalid phone number')
}

const emailAddress = (value) => {
  if (value === '')
    throw new Error('Please enter email address')
    // eslint-disable-next-line
    else if (!/^\w+([\.-]?\w+)+@\w+([\.:]?\w+)+(\.[a-zA-Z0-9]{2,10})+$/.test(value))
    throw new Error('Invalid email address')
}

export default {
  required,
  text,
  address,
  emailAddress,
  phoneNumber,
  addressText,
}
